<template>
  <div>
    <div id="All">
      <div class="all_left">
        <div class="left_top">
          <div class="sale">
            <p>累计达成销售额</p>
            <span>(RMB`000)</span>
          </div>
          <b>{{ salesValue | NumFormat }}</b>
        </div>
        <!-- <div class="left_top">
          <div class="sale">
            <p>全网阶段目标</p>
            <p>第一波完成率</p>
          </div>
           <div class="dachen">
          <b>{{ targetValue | NumFormat }}</b>
          <span>{{Proportion}}%</span>
          </div>
        </div> -->
        <div class="left_top">
          <div class="sale">
            <p>全网总目标</p>
            <p>总完成率</p>
          </div>
          <div class="dachen">
          <b>{{ allTargetValue | NumFormat }}</b>
          <span>{{allProportion}}%</span>
          </div>
        </div>
      </div>
      <div class="middle"></div>
      <div class="all_right">
        <p>总完成率</p>
        <!-- <p>第一波完成率</p> -->
        <Circular :Proportion="allProportion" :bindEl="bindEl"></Circular>
      </div>
    </div>
  </div>
</template>
<script>
import Circular from "@/components/public/circular";
export default {
  data() {
    return {
      allProportion:0,
      Proportion: 0,
      salesValue: 0,
      targetValue: 0,
      allTargetValue: 0,
      bindEl: "PosAll",
      time: "",
    };
  },
  components: {
    Circular,
  },
  methods: {
    getSum() {
      this.$addr.post("Sales/getSalesSumData").then((res) => {
        // console.log(res.data.data[0])
        this.Proportion = Math.round(parseFloat(res.data.data[0].today_achieving))||"0";
        this.salesValue = res.data.data[0].salesValue;
        this.targetValue = res.data.data[0].today_target;
        this.allProportion= Math.round(parseFloat(res.data.data[0].achieving))
        this.allTargetValue=res.data.data[0].targetValue
        
      });
    },
  },
  created() {
    this.getSum();
  },
  props: ["upTime"],
  watch: {
    upTime: {
      handler(newVal, oldVal) {
        this.time = newVal.replace("-", "月");
      },
    },
  },
};
</script>
<style scoped>
#All {
  overflow: hidden;
  clear: both;
  display: flex;
  box-sizing: border-box;
  text-align: center;
}
.all_left {
  width: 225px;
  margin: 30px 19px 50px 32px;
}
.all_left .left_top {
  display: flex;
  font-family: "PingFangSC-Medium";
  font-size: 13px;
  justify-content: space-between;
}
.Tmall_left .left_top p {
  line-height: 0.382979rem;
  color: #191919;
  flex: 1;
  min-width: 80px;
  text-align: right;
}
.all_left .left_top span {
  font-size: 11px;
  line-height: 18px;
  color: rgba(13, 13, 13, 0.3);
}
.all_left .left_top .sale span{
  line-height: 25px;
}
.sale {
  min-width: 90px;
  text-align: right;
  margin: 0 12px 20px 0;
}
.dachen{
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: start;
}
.dachen span{
   font-weight: bold;
  font-size: 14px !important;
   color: #191919 !important;
  text-align: right;
  width: 100%;
  line-height: 10px !important;
}
.all_left .left_top b {
  opacity: 0.91;
  font-family: "Arial-BoldMT";
  font-size: 20px;
  color: #282828;
  text-align: center;
}
.middle {
  margin: 20px 0;
  width: 1px;
  height: 180px;
  border: 1px solid rgba(157, 157, 157, 0.4);
}
.all_right {
  margin: 0 31px 22px 19px;
  padding: 20px 0;
  width: 187px;
  text-align: center;
  position: relative;

}
.all_right p {
  font-family: "PingFangSC-Medium";
  font-size: 13px;
  color: #191919;
  text-align: center;
}
</style>




// WEBPACK FOOTER //
// src/components/Pos/pos_all.vue